module.exports = __webpack_public_path__ + "static/media/drata.8da001e7.svg";